// 实名认证
export default {
  namespaced: true,
  state: {
    // 用户名
    userName: localStorage.getItem('userName') || '',
    // 用户身份证
    idCardNumber: localStorage.getItem('idCardNumber') || '',
    // 识别后的身份证
    identificationIDNumber: localStorage.getItem('identificationIDNumber') || '',
    // 识别后的用户名
    identityUserName: localStorage.getItem('identityUserName') || '',
    // 要进行实名认证的用户id
    userId: localStorage.getItem('userId') || '',
    // 业务类型
    businessType: localStorage.getItem('businessType') || ''
  },
  mutations: {
    // 保存业务类型
    setBusinessType(state,str) {
      state.businessType = str
      localStorage.setItem('businessType',str)
    },
    // 保存用户id
    setUserId(state,str) {
      state.userId = str
      localStorage.setItem('userId',str)
    },
    // 保存用户名
    setUserName(state,str) {
      state.userName = str
      localStorage.setItem('userName',str)
    },
    // 保存用户身份证号码
    setIdCardNumber(state,str) {
      state.idCardNumber = str
      localStorage.setItem('idCardNumber',str)
    },
    // 保存识别后的身份证号码
    setIdentityNumber(state,str) {
      state.identificationIDNumber = str
      localStorage.setItem('identificationIDNumber',str)
    },
    // 保存识别后的用户名
    setIdentityUserName(state,str) {
      state.identityUserName = str
      localStorage.setItem('identityUserName',str)
    },
    // 清空实名认证本地存储数据
    clearLocalStorage(state) {
      state.userName = ''
      state.idCardNumber = ''
      state.identificationIDNumber = ''
      state.identityUserName = ''
      state.userId = ''
      state.businessType = ''
      localStorage.removeItem('userName')
      localStorage.removeItem('idCardNumber')
      localStorage.removeItem('identificationIDNumber')
      localStorage.removeItem('identityUserName')
      localStorage.removeItem('userId')
      localStorage.removeItem('businessType')
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/relNameAuth.js